module.exports = __webpack_public_path__ + "static/media/toa-title.34452757.svg";